export default [
  {
    path: '/',
    meta: { hiddenGroupSelector: true },
    components: {
      header: () => import('../views/common/header'),
      gnb: () => import('../views/common/gnb'),
      default: () => import('../views/overview/whole'),
    },
  },
  {
    path: '/login',
    meta: { exceptAuth: true, isLoginForm: true },
    components: {
      default: () => import('../views/common/Login.vue'),
    },
  },
  {
    path: '*',
    meta: { exceptAuth: true },
    default: () => import('../views/common/NotFound.vue'),
  },
];
